import { render } from "./ApprovedPayments.vue?vue&type=template&id=0f3202c7"
import script from "./ApprovedPayments.vue?vue&type=script&lang=js"
export * from "./ApprovedPayments.vue?vue&type=script&lang=js"

import "./ApprovedPayments.vue?vue&type=style&index=0&id=0f3202c7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__